// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"261":"locale-fr-json","990":"locale-en-json"}[chunkId] + "." + {"261":"8466f016","990":"837ac9b4"}[chunkId] + ".js";
};